import { request } from './index';
import { ExamChartType, ExamOverviewType } from './exam';
import { getStudentExamQueryKey } from '../hooks/react-query/use-student-exam';

export type LessonRepotDataType = {
  lessonName: string;
  correctCount: number;
  wrongCount: number;
  count: number;
};

export type StudentExamType = {
  id: number;
  exam: ExamOverviewType;
  status: 0 | 1 | 2;
  started: string;
  finished: string;
  duration: string;
  remainSeconds: number;
  correctQuestionCount: number;
  wrongQuestionCount: number;
  result?: number;
  rank?: number;
  normalizedResult?: number | null;
  data?: LessonRepotDataType[];
};

export type StudentExamChartType = {
  id: number;
  exam: ExamChartType;
  result?: number;
  normalizedResult?: number | null;
};

export async function fetchStudentExams(): Promise<StudentExamType[]> {
  return await request(true, { url: '/students/student-exams' });
}

export async function fetchStudentExam({
  queryKey: [_, { examId }]
}: {
  queryKey: ReturnType<typeof getStudentExamQueryKey>;
}): Promise<StudentExamType> {
  return await request(true, { url: `/students/student-exams/e-${examId}` });
}

export async function fetchStudentExamsChartData(): Promise<StudentExamChartType[]> {
  return await request(true, { url: '/students/student-exams/chart-data' });
}

export async function startStudentExam(studentExamId: number): Promise<StudentExamType> {
  return await request(true, {
    method: 'PATCH',
    url: `/students/student-exams/${studentExamId}/start`
  });
}

export async function finishStudentExam(studentExamId: number): Promise<StudentExamType> {
  return await request(true, {
    method: 'PATCH',
    url: `/students/student-exams/${studentExamId}/finish`
  });
}
